const fb = require('../firebase.js');
const { Vente } = require("../classes/Vente.js");
import store from '../store';


class ListeVentes {
    constructor() {
        this.liste = [];
    }
    async getVentes() {
        const query = await fb.db.collection("ventes").where('visible', '==', true).get();
        const resultats = [];
        query.forEach(async doc => {
            resultats.push(new Vente(doc.id, doc.data().pointRelais, doc.data().panier, doc.data().grammes, doc.data().details, doc.data().profile));
        });
        this.liste = resultats
        store.commit("setListeVentes", this);
    }
}

export default ListeVentes;